type Props = {
  value: number;
  label?: string;
  width?: number | string;
};

export function ProgressCell({ value, label, width = "100%" }: Props) {
  const pct = Math.max(0, Math.min(100, Number.isFinite(value) ? value : 0));
  const text = label ?? `${Math.round(pct)}%`;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 0, width }}>
      <div
        style={{
          flex: 1,
          height: 8,
          background: "var(--line)",
          borderRadius: 999,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: "100%",
            background: "var(--success-600)",
            borderRadius: 999,
            transition: "width 200ms ease",
          }}
        />
      </div>
      <span
        className="mono"
        style={{
          fontSize: 12,
          color: "var(--ink-3)",
          minWidth: 40,
          textAlign: "right",
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </span>
    </div>
  );
}
